import { Button } from "@similarweb/ui-components";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { translate } from "app/filters/i18nFilter";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import { WithKeysInput } from "app/pages/sales-intelligence/sub-modules/management/hocs/withKeysInput";
import { allTrackers } from "app/services/track/track";
import { useDeleteModalProps } from "../../hooks/useDeleteModalProps";
import { CUSTOM_DELETE_FIELD_MODAL_STYLES, StyledContent, StyledFooter, StyledModalTitle } from "./styles";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

type DeleteFieldModalPros = {
    exportName: string;
};

export const DeleteFieldModal = ({ exportName }: DeleteFieldModalPros) => {
    const { integrationName } = getIntegrationNameFromUrl();
    const { deletableField, setDeletableField, deleteSetting } = useDeleteModalProps(integrationName as Integration);

    const onCancel = () => setDeletableField(undefined);

    const onDelete = () => {
        allTrackers.dispatchTrackEvent(
            `${integrationName} integration`,
            "remove field",
            `export/${exportName}/${deletableField?.title}`,
        );
        if (deletableField) {
            deleteSetting(deletableField);
        }
    };

    const isOpen = Boolean(deletableField?.externalField);

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            customStyles={CUSTOM_DELETE_FIELD_MODAL_STYLES}
        >
            <WithKeysInput
                onEnter={onDelete}
                onEscape={onCancel}
            >
                <StyledModalTitle>{translate("si.management.sf.settings_export.modal.delete.title")}</StyledModalTitle>
                <StyledContent
                    dangerouslySetInnerHTML={{
                        __html: translate(`si.management.sf.settings_export.modal.delete.content`, {
                            fieldName: deletableField?.title,
                            integrationName: integrationName === "hubspot" ? "HubSpot" : integrationName,
                        }),
                    }}
                />

                <StyledFooter>
                    <Button
                        type="flatDark"
                        onClick={onCancel}
                    >
                        {translate("si.management.sf.settings_export.modal.delete.btn.cancel")}
                    </Button>
                    <Button
                        type="warning"
                        onClick={onDelete}
                    >
                        {translate("si.management.sf.settings_export.modal.delete.btn.remove")}
                    </Button>
                </StyledFooter>
            </WithKeysInput>
        </ProModal>
    );
};
